import { Box, SxProps, Tooltip, Typography, styled } from '@mui/material'
import React from 'react'
import { Flex } from 'src/styles/flexComponent'
import { GetRGBA } from 'src/utils'
import { convertFirstLetterToUpperCase, formatNumber } from '../../utils/function'

interface StyledCardProps {
  customChipWidth?: any
}

interface CountWithIconBoxProps {
  Component?: any
  value?: any
  iconBgColor?: any
  title?: any
  color?: any
  styles?: any
  customChipWidth?: any
  bgColor?: any
  sx?: SxProps | undefined
}

const CountWithIconBox: React.FC<CountWithIconBoxProps> = ({
  Component,
  value,
  iconBgColor,
  title,
  color,
  styles = {},
  customChipWidth,
  bgColor,
  sx,
}) => {
  return (
    <Tooltip title={convertFirstLetterToUpperCase(title)}>
      <StyledCard customChipWidth={customChipWidth} bgcolor={bgColor}>
        <Flex.Row>
          <IconBox sx={{ backgroundColor: iconBgColor }}>
            <Component sx={sx} />
          </IconBox>
          <Number sx={styles} variant="body2" color={color}>
            {formatNumber(value, 2)}
          </Number>
        </Flex.Row>
      </StyledCard>
    </Tooltip>
  )
}

export default CountWithIconBox

const Number = styled(Typography)(() => ({
  paddingLeft: '3px',
  textAlign: 'right',
  fontWeight: 600,
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
}))

const IconBox = styled(Box)(() => ({
  padding: '3px',
  height: '20px',
  width: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
}))

const StyledCard = styled(Box)<StyledCardProps>(({ theme, customChipWidth }) => ({
  width: customChipWidth ?? '',
  height: '26px',
  padding: '2px 4px',
  fontSize: '12px',
  display: 'flex',
  flexDirection: 'row',
  borderRadius: '11px',
  border: `0.5px solid ${GetRGBA(theme.palette.secondaryMain[theme.palette.mode], 1)}`,
}))
